import axios from '@/http/axios'

export default {
  fetchFullStructure: (config) => {
    return axios.get(`/risk-profile-sections/full-structure/`, config)
  }
}